import styled from 'styled-components';

import { ArrowSlimIcon } from '@/assets/icons/v2';

const ARROW_SIZE = '1.5rem';

interface TitleProps {
	$underline: boolean;
}

interface ArrowProps {
	$open: boolean;
}

export const Header = styled.button`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	width: 100%;
	min-height: 4rem;
	padding: 1rem 0.5rem;
	background: transparent;
	border: none;
	cursor: pointer;
	text-align: left;
`;

export const Title = styled.span<TitleProps>`
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1.5625rem;
	font-weight: 600;
	line-height: 2rem;
	letter-spacing: -0.0078rem;
	text-decoration: ${({ $underline }) => ($underline ? 'underline' : 'none')};
`;

export const TitleLink = styled(Title)`
	cursor: pointer;
	text-decoration: underline;

	&:hover {
		color: ${({ theme }) => theme.palette.primary[600]};
	}
`;

export const InfoMark = styled.span`
	display: inline-flex;
	color: ${({ theme }) => theme.palette.secondary[400]};

	svg {
		width: 1rem;
		height: 1rem;
	}
`;

export const Arrow = styled(ArrowSlimIcon)<ArrowProps>`
	display: block;
	width: ${ARROW_SIZE};
	height: ${ARROW_SIZE};
	color: ${({ theme }) => theme.palette.secondary[400]};
	transform: rotate(${({ $open }) => ($open ? '180deg' : '0deg')});
	transition: transform 0.2s;
`;

export const Divider = styled.hr`
	width: 100%;
	margin: 0;
	border: none;
	border-top: 1px solid ${({ theme }) => theme.palette.secondary[200]};
`;

export const Body = styled.div`
	padding-top: 1rem;
`;
